module.exports = __webpack_public_path__ + "static/media/3.b7d333c5.jpg";